import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import AppText from "components/AppText";

const AppModal = (props: any) => {
  const {
    open,
    title,
    children,
    onScroll,
    className,
    modalWidth,
    handelDone,
    handleClose,
    handleCancel,
    doneButtonText,
    cancelButtonText,
    dialogContentStyle,
  } = props;

  return (
    <Dialog
      open={open}
      keepMounted
      fullWidth={true}
      onScroll={onScroll}
      className={`app-modal-dialog ${className || ""}`.trim()}
      onClose={handleClose}
      maxWidth={modalWidth || "xs"}
      PaperProps={{
        className: "app-modal-dialog__paper",
        sx: {
          backgroundColor: "var(--bg-surface)",
          backgroundImage: "none",
          color: "var(--text-primary)",
          border: "1px solid var(--border-default)",
          borderRadius: "12px",
          boxShadow: "var(--shadow-md)",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "var(--bg-overlay)",
        },
      }}
    >
      {title && (
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "var(--text-primary)" }}
        >
          {title}
        </DialogTitle>
      )}
      <DialogContent
        style={dialogContentStyle}
        sx={{
          backgroundColor: "var(--bg-surface)",
          color: "var(--text-primary)",
        }}
      >
        {children}
      </DialogContent>
      {(handleCancel || handelDone) && (
        <DialogActions
          sx={{
            backgroundColor: "var(--bg-surface)",
            borderTop: "1px solid var(--border-muted)",
          }}
        >
          <Button onClick={handleCancel} sx={{ color: "var(--text-secondary)" }}>
            <AppText>{cancelButtonText || "Cancel"}</AppText>
          </Button>
          <Button onClick={handelDone} sx={{ color: "var(--color-primary)" }}>
            <AppText>{doneButtonText && "Ok"}</AppText>
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default AppModal;
